<template>
  <div id="app">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup>
// Main app component
useHead({
  title: 'Technomac-snc - Your Best Partner in Graphic Industry',
  meta: [
    { name: 'description', content: 'We are experts in new and used machinery for the graphic arts. Find your perfect machine with our comprehensive catalog and expert support.' }
  ]
})

// Load Roboto Slab + Inter from Google Fonts for headings and body
useHead({
  link: [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;800&family=Roboto+Slab:wght@300;400;500;700&display=swap' }
  ]
})

// Load Roboto Slab + Inter from Google Fonts for headings and body
useHead({
  link: [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;800&family=Roboto+Slab:wght@300;400;500;700&display=swap' }
  ]
})

// Language initialization logic - client-side only to prevent hydration mismatches
const { locale, setLocale } = useI18n()

// Initialize language from cookie/localStorage on app load
onMounted(() => {
  try {
    // Check for saved locale in cookie first (matches backend)
    const cookies = document.cookie.split(';')
    let savedLocale = null

    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=')
      if (name === 'locale') {
        savedLocale = value
        break
      }
    }

    // Fallback to localStorage if no cookie
    if (!savedLocale) {
      savedLocale = localStorage.getItem('locale')
    }

    // Validate and set locale
    const validLocales = ['en', 'it', 'fr']
    const targetLocale = (savedLocale && validLocales.includes(savedLocale)) ? savedLocale : 'en'

    if (targetLocale !== locale.value) {
      setLocale(targetLocale)
    }
  } catch (error) {
    console.warn('Failed to initialize locale:', error)
  }
})

// Import CSS
import '~/assets/css/search-interface.css'
</script>

<style>
/* Global styles */
html, body {
  @apply antialiased;
  overflow-x: hidden;
  max-width: 100vw;
  width: 100%;
}

#app {
  @apply min-h-screen;
  overflow-x: hidden;
  max-width: 100vw;
  width: 100%;
}

/* Ensure all direct children don't cause overflow */
#app > * {
  max-width: 100%;
}

/* Reset any elements that might cause layout issues */
* {
  box-sizing: border-box;
}

/* Fix Tailwind container issues */
.container {
  max-width: 100% !important;
}
</style>
